<template>
  <div class="news"
       id="newstop">
    <En_topper></En_topper>
    <div class="nei_tit">
      <img src="../assets/news_tit.jpg"
           alt="" />
      <span>ENN News</span>
    </div>
    <ul>
      <li v-for="(item, index) in list"
          :key="index">
        <a @click="detail(item.launchId, item.articleType, item.contentName)">
          <img :src="item.creationPublishCoverUrl" />
          <i>{{ item.createTime.split("-")[0] }}/{{
              item.createTime.split("-")[1]
            }}/{{ item.createTime.split("-")[2].split(" ")[0] }}</i>
          <span>{{ item.creationTitle }}</span>
          <p>{{ item.creationAbstract }}</p>
        </a>
      </li>
    </ul>
    <a class="more"
       @click="loadNews()"
       v-if="page <= allPage">MORE...</a>
    <En_footer></En_footer>
  </div>
</template>

<script>
import En_topper from "./En_topper";
import En_footer from "./En_footer";
export default {
  components: {
    En_topper,
    En_footer
  },
  name: "En_news",
  data () {
    return {
      list: [],
      page: 1,
      allPage: 0
    };
  },
  methods: {
    init () {
      if (
        localStorage.getItem("typeface") &&
        localStorage.getItem("typeface") === "繁体"
      ) {
        this.langType = "t";
        // eslint-disable-next-line no-undef
        zh_tran("t");
        this.$nextTick(() => {
          this.langType = "t";
          // eslint-disable-next-line no-undef
          zh_tran("t");
        });
      } else {
        this.langType = "s";
        // eslint-disable-next-line no-undef
        zh_tran("s");
        this.$nextTick(() => {
          this.langType = "s";
          // eslint-disable-next-line no-undef
          zh_tran("s");
        });
      }
    },
    detail (id, type, content) {
      if (type === 1) {
        this.$router.push({ path: "En_newsDetail", query: { id: id } });
      } else {
        window.open(content);
      }
    },
    loadNews () {
      this.$http
        .get("/news/enlist/list-" + this.page + ".json")
        .then(response => {
          this.page++;
          this.allPage = response.data.pages;
          this.list = [...this.list, ...response.data.records];
          this.init();
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted () {
    let maodian = this.$route.params.maodian;
    console.log(maodian);
    if (maodian) {
      const targetElement = document.querySelector(maodian);
      window.scrollTo({ top: targetElement.offsetTop, behavior: "smooth" });
    } else {
      window.scrollTo(0, 0);
    }
    this.loadNews();
  }
};
</script>

<style scoped>
.news {
  background: #f1f2f6;
  width: 750px;
  height: auto;
  overflow: hidden;
}
.nei_tit {
  width: 750px;
  height: 450px;
  position: relative;
  margin-top: 95px;
}
.nei_tit img {
  width: 750px;
  height: 450px;
  position: absolute;
  left: 0;
  top: 0;
}
.nei_tit span {
  position: absolute;
  left: 40px;
  top: 200px;
  font-size: 48px;
  color: #fff;
  font-weight: 500;
}
.news ul {
  padding-top: 40px;
}
.news ul li {
  width: 750px;
  height: 820px;
  overflow: hidden;
  margin-bottom: 25px;
  background: #fff;
}
.news ul li img {
  width: 750px;
  height: 475px;
}
.news ul li i {
  font-family: dingding;
  font-size: 28px;
  color: #07437f;
  text-align: left;
  display: block;
  width: 700px;
  height: 30px;
  line-height: 30px;
  padding: 35px 25px 20px 25px;
  font-style: normal;
}
.news ul li span {
  display: block;
  width: 700px;
  height: 100px;
  line-height: 50px;
  float: left;
  font-size: 36px;
  color: #1d2129;
  text-align: left;
  padding: 0 25px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.news ul li p {
  float: left;
  display: block;
  width: 700px;
  height: 80px;
  line-height: 40px;
  font-size: 28px;
  color: #323233;
  text-align: left;
  margin: 20px 25px 40px 25px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.news .more {
  width: 200px;
  height: 80px;
  background: url(../assets/morebg.png);
  background-size: 100% 100%;
  font-size: 28px;
  display: block;
  margin: 0 auto;
  line-height: 80px;
  color: #1d2129;
}
</style>
